import {useCallback} from 'react';

import {useCommonDataHook} from 'src/hooks/use-common-data-hook';
import {getCrmLimits, saveCrmLimits} from 'src/openapi/admin/apis/CrmLimitsControllerApi';
import {useAppDispatch} from 'src/store/hooks';

import type {CrmType} from 'src/openapi/admin/models/CrmType';
import type {GetCrmLimit} from 'src/openapi/admin/models/GetCrmLimit';

type Props = {
    accountId: number,
    licenseId: number,
    crmType: CrmType,
};

export const useCrmLimits = ({accountId, licenseId, crmType}: Props) => {
    const apiDispatch = useAppDispatch();

    const getDispatchAction = useCallback(() => apiDispatch(getCrmLimits({
        accountId,
        licenseId,
        crmType,
    })), [accountId, licenseId, crmType, apiDispatch]);

    const saveDispatchAction = useCallback((crmLimits: GetCrmLimit) => apiDispatch(saveCrmLimits({
        licenseId,
        crmType,
        saveCrmLimit: {
            maxUsers: crmLimits.maxUsers,
            maxImports: crmLimits.maxImports,
            importCredit: crmLimits.importCredits || 0,
        },
    })), [licenseId, crmType, apiDispatch]);

    return useCommonDataHook({
        getDispatchAction,
        saveDispatchAction,
        initValue: {currentUsers: 0, maxUsers: 0},
    });
};
